export const sanitizeUrl = (url: string) => {
  let baseUrl: URL | undefined
  try {
    baseUrl = new URL(url)
  } catch {
    // do nothing, the URL was null or malformed. This can happen when document.referrer is null.
  }

  if (!baseUrl) {
    return '' // we return empty string here instead of undefined so that FF document.referrer logic does not accidentally leak a hash. at the time of writing, FF DOES sanitize query strings, but NOT hashes
  }

  const { origin, pathname } = baseUrl

  return origin + pathname
}

type Map = {
  [key: string]: any
}

/** Overwrites keys from an object with temporary values, executes a function, and then reverts to the original object key values.
 *
 * @param object The parent object to overwrite properties of.
 * @param temporaryKeyValueMap A map of keys found in the object, and temporary values to assign them.
 * @param fx A function to perform with the temporary values.
 */
export const temporary = (
  object: Map,
  temporaryKeyValueMap: Map,
  fx: Function,
) => {
  let originals: Map = {}
  Object.entries(temporaryKeyValueMap).forEach(([key, value]) => {
    originals[key] = object[key]
    object[key] = value
  })
  fx()
  Object.entries(temporaryKeyValueMap).forEach(([key]) => {
    object[key] = originals[key]
  })
}

/**
 *
 * Silences the console while running the provided function.
 */
export const silence = (fx: Function) => {
  temporary(
    console,
    {
      log: jest.fn(),
      warn: jest.fn(),
      error: jest.fn(),
      debug: jest.fn(),
      info: jest.fn(),
      trace: jest.fn(),
    },
    fx,
  )
}
